import { Users } from 'lucide-react'

import { Card, CardContent } from '@/ui/card'
import { cn } from '@/core/lib/utils'
import type { ClassSession } from '@/features/classes/stores'

interface SessionOverviewProps {
  session: ClassSession
  attendeeCount: number
}

export function SessionOverview({ session, attendeeCount }: SessionOverviewProps) {
  const max = session.maxAttendees ?? 20
  const remaining = Math.max(max - attendeeCount, 0)
  const pct = Math.min((attendeeCount / max) * 100, 100)
  const full = attendeeCount >= max
  const warning = !full && attendeeCount >= max * 0.8

  return (
    <Card>
      <CardContent className="p-4">
        <div className="flex flex-col sm:flex-row sm:items-center gap-4">
          <div>
            <p className="text-sm font-medium text-navy flex items-center gap-2">
              <Users className="w-4 h-4 text-primary" />
              Attendees
            </p>
            <div className="flex items-center gap-3 mt-1">
              <span className={cn('text-sm font-semibold', full ? 'text-red-500' : warning ? 'text-orange-500' : 'text-green-600')}>
                {attendeeCount} / {max}
              </span>
              <span className="text-xs text-slate-500">{remaining} spots remaining</span>
            </div>
            <div className="mt-2 w-full max-w-xs">
              <div className="h-2 w-full bg-slate-150 rounded-full overflow-hidden">
                <div
                  className={cn('h-full rounded-full transition-all', full ? 'bg-red-500' : warning ? 'bg-orange-500' : 'bg-green-500')}
                  style={{ width: `${pct}%` }}
                />
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
